$(function () { 
    
    // ACCORDION Toggle (Multiple Items)    
    if ($('.acc .acc-head').length > 0) {
        $('.acc .acc-head').click(function () { 
            var parent = $(this).parent();

            // Baaki parent panels close karo
            $('.acc').not(parent).removeClass('acc-active').find('.acc-body').slideUp();

            parent.toggleClass('acc-active');
            parent.find('.acc-body').stop().slideToggle();
        });
    }


    //// ACCORDION 2 Toggle (Multiple Items)
    if($('.panel .panel-head').length > 0)
    {
        $('.panel .panel-head').click(function(){
            var parent = $(this).parent();        
            parent.toggleClass('active');
            parent.find('.panel-body').stop().slideToggle();
            parent.siblings().find('.panel-body').hide();
            parent.siblings().removeClass('active');
        }); 
    }
});




